import { render, staticRenderFns } from "./UnderlinedText.vue?vue&type=template&id=85d5d8ee&scoped=true"
import script from "./UnderlinedText.vue?vue&type=script&lang=js"
export * from "./UnderlinedText.vue?vue&type=script&lang=js"
import style0 from "./UnderlinedText.vue?vue&type=style&index=0&id=85d5d8ee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5d8ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85d5d8ee')) {
      api.createRecord('85d5d8ee', component.options)
    } else {
      api.reload('85d5d8ee', component.options)
    }
    module.hot.accept("./UnderlinedText.vue?vue&type=template&id=85d5d8ee&scoped=true", function () {
      api.rerender('85d5d8ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/UnderlinedText.vue"
export default component.exports